import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import TitleListSortingSwitchPopover from '@/components/list/sorting/TitleListSortingSwitchPopover.vue';

import { CollectionType } from '@/enums/collection-type';
import { TitleOrder } from '@/enums/title-order';

import { defaultSortingItemSelectedKeys, sortingItemsByCollectionType } from '@/helpers/list-sorting-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { PopoverHelper } from '@/helpers/vfm/popover-helper';
import { faChevronDown, faSortAlphaDownAlt } from '@fortawesome/free-solid-svg-icons';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { useUserStore } from '@/stores/pinia/useUserStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleListSortingSwitcher',
  props: {
    collectionType: null,
    type: { default: 'icon' }
  },
  setup(__props: any) {

const props = __props as { collectionType: CollectionType, type: 'icon' | 'label' };



const { filters } = useFilterStore();
const { isProWebLocale } = storeToRefs(useLanguageStore());
const { queryParams } = storeToRefs(useRoutingStore());
const { showFreemium } = storeToRefs(useUserStore());

const defaultSortingItemKey = computed(() => defaultSortingItemSelectedKeys[props.collectionType]);

const sortingItems = computed(() => {
	if (!isProWebLocale.value && !showFreemium.value) {
		return sortingItemsByCollectionType[props.collectionType].filter(item => !item.premium);
	}
	return sortingItemsByCollectionType[props.collectionType];
});

const sortByFilter = computed<TitleOrder>(() => {
	if (queryParams.value.sort_by) {
		// check if sorty_by is supported in the sort list
		const hasSortingItem = sortingItems.value.some(item => item.key === queryParams.value.sort_by);
		return hasSortingItem ? (queryParams.value.sort_by as TitleOrder) : defaultSortingItemKey.value;
	}
	// To-Do: GraphQL cleanup
	return (filters().sort_by as TitleOrder) || defaultSortingItemKey.value;
});

const selectedItem = computed(() => sortingItems.value.find(item => item.key === sortByFilter.value));

const isActive = computed(() => defaultSortingItemKey.value !== sortByFilter.value);

function openSelection(event: Event) {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'sorting_dropdown_clicked',
	});

	PopoverHelper.create({
		popoverProps: {
			cssClass: 'static-pages-popover',
			boundingElement: event.currentTarget,
		},
		component: TitleListSortingSwitchPopover,
	});
}

return { __sfc: true,props, filters, isProWebLocale, queryParams, showFreemium, defaultSortingItemKey, sortingItems, sortByFilter, selectedItem, isActive, openSelection, faChevronDown, faSortAlphaDownAlt }
}

})